// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"726":"8accfdab","921":"39fd693c"}[chunkId] + ".chunk.js";
};